module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAUCAYAAAC07qxWAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACTSURBVHgBndEBDYAgEAVQZgIiGMEINtAGGsEG0AAj2IAI2oAIRCDCeZtsnm5357ztb2y8MfgYAHCYiLFGGgQZroka7OGeoOGF4EXDnuBRw1uFBdNJ0GJSxRnTSrglTSSxtorLn9rmRrADWR/caU7tFTcmgjyHOvKIlUOPWjhkCeKLxo39Cwrk8uL/JrGG1yN6o8wJQV4OpEypYdcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/balance_img.png
// module id = LZcC
// module chunks = 1